import React from 'react';
import { usePeriod } from '@/context/PeriodContext';
import { MONTH_NAMES, currentYearMonth } from '@/lib/format';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export default function PeriodPicker() {
  const { year, month, setPeriod } = usePeriod();
  const current = currentYearMonth();
  const isCurrent = year === current.year && month === current.month;

  const shift = (delta) => {
    let m = month + delta, y = year;
    if (m < 1) { m = 12; y -= 1; }
    if (m > 12) { m = 1; y += 1; }
    setPeriod(y, m);
  };

  return (
    <div className="flex items-center justify-between rounded-full border border-border bg-card p-1.5">
      <button data-testid="period-prev" onClick={() => shift(-1)} className="h-9 w-9 rounded-full flex items-center justify-center hover:bg-secondary active:scale-95">
        <ChevronLeft className="h-4 w-4"/>
      </button>
      <div className="flex-1 text-center">
        <span className="font-display font-bold text-sm" data-testid="period-label">{MONTH_NAMES[month - 1]} {year}</span>
        {isCurrent && (
          <button data-testid="period-today" onClick={() => setPeriod(current.year, current.month)} className="ml-2 text-[10px] uppercase tracking-widest text-primary font-semibold">Hoy</button>
        )}
      </div>
      <button data-testid="period-next" onClick={() => shift(1)} className="h-9 w-9 rounded-full flex items-center justify-center hover:bg-secondary active:scale-95">
        <ChevronRight className="h-4 w-4"/>
      </button>
    </div>
  );
}
